<template>
  <div>
    <StartpageContainer />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import StartpageContainer from "@/components/startpage/container/StartpageContainer.vue";

export default Vue.extend({
  components: {
    StartpageContainer,
  },
});
</script>
